export class SubjectResolution {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "topic",
            "baseName": "topic",
            "type": "string",
            "format": ""
        },
        {
            "name": "expectedSubject",
            "baseName": "expectedSubject",
            "type": "string",
            "format": ""
        },
        {
            "name": "found",
            "baseName": "found",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "schemaId",
            "baseName": "schemaId",
            "type": "number",
            "format": ""
        },
        {
            "name": "latestVersion",
            "baseName": "latestVersion",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SubjectResolution.attributeTypeMap;
    }
    constructor() {
    }
}
